/* projects/speaker-platform/src/app/pages/admin/seances-operation/seances-operation.component.scss */
/*# sourceMappingURL=seances-operation.component-KALKYXBD.css.map */
